export default {
  name: 'barWidget1',
  globals: {
    variables: {
      since: 'now-1h',
      until: 'now',
    },
  },
  spec: {
    datasources: {
      countByInstanceType: {
        type: 'uql',
        options: {
          since: '/${ globals.variables.since }',
          until: '/${ globals.variables.until }',
          queryStr: 'FETCH attributes(cloud.host.type), count FROM entities(aws:ec2)',
        },
      },
    },
    view: [
      [
        'dashify:CardWithTitle',
        { title: 'EC2 Instances by Type' },
        [
          [
            'dashify:Bar',
            {
              highchartsConfig: {
                xAxis: {
                  categories:
                    '/${ $map($sort(data.countByInstanceType.data, function($l, $r){ $l.count < $r.count}), function($instance){ $instance.cloud_host_type })[] }',
                },
                series:
                  "/${ $sort(data.countByInstanceType.data, function($l, $r){ $l.count < $r.count}){'name': 'Cloud Host Type', 'data': count} }",
              },
            },
          ],
        ],
      ],
    ],
  },
};
